import React from 'react'
// context
import { ObjectiveContext } from 'context/index'
// graphql
import { PLAN_OBJECTIVE_RESOURCES_LIST_QUERY } from 'graphql/planObjectives/queries'
// types
import { LogEntityTypes } from 'types/graphql'
// view components
import ResourcesListContainer from 'containers/Activities/components/ResourcesList'

const ObjectiveResourcesList: React.FC = () => {
  const { entity } = React.useContext(ObjectiveContext) as any

  const { objectiveCreateResource, objectiveDeleteResource, objectiveModifyResource } = entity.currentPermissions

  return (
    <ResourcesListContainer
      canCreate={objectiveCreateResource}
      canDelete={objectiveDeleteResource}
      canModify={objectiveModifyResource}
      entity={{ ...entity, entityType: LogEntityTypes.Objective }}
      query={PLAN_OBJECTIVE_RESOURCES_LIST_QUERY}
      variables={{
        filter: {
          planObjectiveId: entity.id
        }
      }}
    />
  )
}

export default ObjectiveResourcesList
